import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/** Regulile XDR ale firmei (incidente, tichete, raspuns, investigatie) si suprimarile active. */

export type XdrPolicyField =
  | 'ticket_min_level'
  | 'group_window_hours'
  | 'ticket_grace_minutes'
  | 'no_answer_minutes'
  | 'action_expiry_minutes'
  | 'power_expiry_minutes'
  | 'timeline_before_minutes'
  | 'timeline_after_minutes'
  | 'sweep_days'
  | 'suppress_days'
  | 'false_positive_undo_minutes'
  | 'log_retention_months'

export const XDR_POLICY_FIELDS: XdrPolicyField[] = [
  'ticket_min_level',
  'group_window_hours',
  'ticket_grace_minutes',
  'no_answer_minutes',
  'action_expiry_minutes',
  'power_expiry_minutes',
  'timeline_before_minutes',
  'timeline_after_minutes',
  'sweep_days',
  'suppress_days',
  'false_positive_undo_minutes',
  'log_retention_months',
]

/** Motorul de detectie: native = OD evalueaza regulile, wazuh = evenimentele pleaca la Wazuh. NULL = native. */
export type XdrEngine = 'native' | 'wazuh'

export type XdrAction = 'isolate' | 'isolate_internal' | 'isolate_external' | 'lock' | 'logoff' | 'shutdown' | 'block_ip' | 'disable_account' | 'none'

export interface XdrRule {
  id: string
  name: string
  level: number
  default: XdrAction
  action: XdrAction
}

/** Motorul de detectie al firmei si starea lui (GET /securitee/xdr-policy). */
export interface XdrEngineStatus {
  engine: XdrEngine
  /** o conexiune Wazuh care merge pentru grupul SIEM al firmei */
  wazuh_ready: boolean
  /** cel mai vechi eveniment neevaluat de motorul nativ; null = nimic in asteptare */
  waiting_minutes: number | null
  detections_24h: number
  stale_minutes: number
  stopped: boolean
}

export interface XdrPolicyPage {
  /** `edr_blind`: detectie cand evenimentele EDR ale unui aparat se opresc (ph4 EdrBlind) */
  values: Record<XdrPolicyField, number> & { detection_engine: XdrEngine; edr_blind: boolean }
  engine_status?: XdrEngineStatus
  own: Record<XdrPolicyField, number | null> & { detection_engine: XdrEngine | null; edr_blind: true | null }
  /** camp => [implicit, minim, maxim] */
  fields: Record<XdrPolicyField, [number, number, number]>
  rules: XdrRule[]
  can_edit: boolean
  updated: { by: string; at: string } | null
}

/** `edr_blind` numai din sectiunea ei: fara el, serverul o lasa cum e */
export type XdrPolicySave = Record<XdrPolicyField, number | string | null> & { recommended: Record<string, XdrAction>; detection_engine: XdrEngine | null; edr_blind?: boolean }

export interface XdrSuppression {
  ID: number
  rule_id: string
  rule: string
  channel: string
  event_id: number
  field: string
  value: string
  reason: string
  created_by: string
  created_at: string
  expires_at: string
  hits: number
  last_hit_at: string | null
  ticket_id: number | null
}

export const XDR_POLICY_KEY = ['securitee', 'xdr-policy'] as const
export const XDR_SUPPRESSIONS_KEY = ['securitee', 'xdr-suppressions'] as const

export function xdrPolicyQuery() {
  return queryOptions({
    queryKey: XDR_POLICY_KEY,
    queryFn: () => apiGet<XdrPolicyPage>('/securitee/xdr-policy'),
  })
}

export function saveXdrPolicy(body: XdrPolicySave): Promise<XdrPolicyPage> {
  return apiPostJson<XdrPolicyPage>('/securitee/xdr-policy', body)
}

export function xdrSuppressionsQuery() {
  return queryOptions({
    queryKey: XDR_SUPPRESSIONS_KEY,
    queryFn: () => apiGet<{ suppressions: XdrSuppression[] }>('/securitee/xdr-suppressions'),
  })
}

export function removeXdrSuppression(id: number): Promise<{ ok: boolean }> {
  return apiPostJson<{ ok: boolean }>(`/securitee/xdr-suppressions/${id}/remove`, {})
}
